import { Scaffold } from 'layouts';
import { useSearchParams } from 'react-router-dom';
import ConnectedWorkspace from 'pages/estadia-prototype/connected-workspace';
import { usePermission } from 'hooks/usePermission';
import { TabbedNavigation } from './components/tabbed-navigation/tabbed-navigation';
import {
  canCreateBilling,
  VIAGENS_CONTROLE_PERMISSIONS as P,
} from 'lib/viagens-controle-permissions';

export default function EstadiaMonitoringPage() {
  const { hasAnyPermissionTo } = usePermission();
  const [searchParams] = useSearchParams();
  const view = searchParams.get('view') || 'timeline';
  const normalizedView = ['operation', 'billing', 'finance'].includes(view) ? 'settlement' : view;
  const historicalView =
    (normalizedView === 'settlement' && hasAnyPermissionTo([P.STAYS])) ||
    (normalizedView === 'invoices' && hasAnyPermissionTo([P.INVOICES])) ||
    (normalizedView === 'reports' && hasAnyPermissionTo([P.MANAGEMENT]));
  const excludeApprovedBilled = !historicalView;
  const createInvoice = canCreateBilling(hasAnyPermissionTo);
  const approveInvoice = hasAnyPermissionTo([P.BILLING_APPROVE]);
  const rejectInvoice = hasAnyPermissionTo([P.BILLING_REJECT]);
  return (
    <Scaffold>
      <TabbedNavigation />
      <ConnectedWorkspace
        excludeApprovedBilled={excludeApprovedBilled}
        access={{
          viewManagement: hasAnyPermissionTo([P.MANAGEMENT]),
          viewStays: hasAnyPermissionTo([P.STAYS]),
          viewBilling: hasAnyPermissionTo([P.INVOICES]),
          validate: hasAnyPermissionTo([P.APPROVE]),
          rejectValidation: hasAnyPermissionTo([P.REJECT]),
          createInvoice,
          viewInvoices: hasAnyPermissionTo([P.INVOICES]),
          approveInvoice,
          rejectInvoice,
          dispatch: approveInvoice,
        }}
      />
    </Scaffold>
  );
}
